// src\components\theme\elements\ThemeColorTools.js

import Konva from 'konva';

/**
 * Convert HEX color code to RGB object.
 * @param {string} hex - The HEX color code.
 * @returns {object} - The RGB representation of the color.
 */
export const hexToRgb = (hex) => {
  hex = hex.replace('#', '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((hexChar) => hexChar + hexChar)
      .join('');
  }
  const int = parseInt(hex, 16);
  return {
    r: (int >> 16) & 255,
    g: (int >> 8) & 255,
    b: int & 255,
  };
};

/**
 * Initialize the custom ColorReplaceFilter.
 * This filter replaces near-white pixels with the specified tint color.
 * It ensures that the filter is defined only once to prevent redefinition errors.
 */
export const initializeColorReplaceFilter = () => {
  if (!Konva.Filters.ColorReplaceFilter) {
    Konva.Filters.ColorReplaceFilter = function (imageData) {
      const data = imageData.data;
      const nPixels = data.length;
      const tintColor = this.getAttr('tintColor'); // Access the 'tintColor' attribute

      if (!tintColor) return; // If tintColor is not set, do nothing

      // Define threshold values
      const threshold = 200; // Adjust based on your needs

      for (let i = 0; i < nPixels; i += 4) {
        const alpha = data[i + 3];

        if (alpha > 0) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];

          // Check if the pixel is near white
          if (r > threshold && g > threshold && b > threshold) {
            data[i] = tintColor.r;     // Red
            data[i + 1] = tintColor.g; // Green
            data[i + 2] = tintColor.b; // Blue
            // Alpha remains unchanged
          }
        }
      }
    };
  }
};
